import API from "./lib/api";
import { voucherHistoryUrl } from "./lib/url";


export const getAllVoucherHistoryApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurant_id}${voucherHistoryUrl}?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}



export const addVoucherHistoryApi = async (voucherHistoryData) => {
    try {
        
        const response = await API.post( 
            `restaurant/voucher-histories`,
            voucherHistoryData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const editVoucherHistoryApi = async (voucherHistoryData, id) => {
    try {
        
        const { data } = await API.put( 
            `${voucherHistoryUrl}/${id}`,
            {...voucherHistoryData}
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}

export const getSingleVoucherHistoryApi = async (id) => {
    try {
        
        const { data } = await API.get( 
            `${voucherHistoryUrl}/${id}`
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}


export const deleteVoucherHistoryApi = async (id) => {
    try {
        
            const response = await API.delete(`restaurant/voucher-histories/${id}`);
            return response.data;
        } catch (error) {
            return (
                error.response?.data || {
                    status: "failure",
                    message: "Something went wrong.",
                }
            );
        }
}